module.exports = __webpack_public_path__ + "img/small.088da1de.jpg";